import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ActivationStatusResponseSchema, ActivationStatusResponse } from "../response/PropertyActivationResponse";

const API_VERSION = "v4";

const TERMINAL_STATUSES = ['completed', 'completed_with_errors', 'failed'];

export interface UsePropertyActivationStatusOptions {
    enabled?: boolean;
    /** Polling interval (ms). Default 1500. */
    refetchInterval?: number;
}

/**
 * Polls the progress of a property activate/deactivate job. Polling stops
 * automatically once `status` reaches a terminal value.
 */
export const usePropertyActivationStatus = (
    propertyId: string | null | undefined,
    activationId: string | null | undefined,
    options?: UsePropertyActivationStatusOptions
) => {
    const pollInterval = options?.refetchInterval ?? 1500;
    const enabled = (options?.enabled ?? true) && !!propertyId && !!activationId;

    return useQuery<ActivationStatusResponse>({
        queryKey: ['property-activation-status', propertyId, activationId],
        enabled,
        queryFn: async () => {
            const response = await privateApi.get(
                `/${API_VERSION}/property/${propertyId}/activation/${activationId}/status`
            );

            return ActivationStatusResponseSchema.parse(response.data);
        },
        refetchInterval: (query) => {
            const status = query.state.data?.data.status;
            if (status && TERMINAL_STATUSES.includes(status)) {
                return false;
            }
            return pollInterval;
        },
        refetchOnWindowFocus: false,
    });
};
